<template>
    <b-card no-body>
        <div class="row">
            <div class="col-12 d-flex justify-content-center">
                <upload-foto @upload="(img) => (form.logoDaEmpresa = img)" :fotoSrc="form.logoDaEmpresa" />
            </div>
            <div class="col-12 d-flex justify-content-center mb-4"><h4>{{form.nomeFantasia}}</h4></div>

            <input-select class="col-12" label="Tipo" :options="options.tipoEmpresa" v-model="form.tipo" ref="tipo" required/>

            <input-mask type="cnpj" :mask="['##.###.###/####-##']" :class="`col-12 col-md-${form.tipo == 'Proponente' ? 6 : 3}`" label="CNPJ" v-model="form.cnpj" ref="cnpj" required/>
            <input-text class="col-12 col-md-3" v-if="form.tipo == 'Proponente'" label="Código ANEEL" v-model="form.codigoANEEL" :max-length="5" ref="codigo" required/>
            <input-date-time :class="`col-12 col-md-3`" v-if="form.tipo == 'Proponente'"  label="Data de inicio de operação" v-model="form.inicioOperacao" ref="inicio" required/>
            <input-select class="col-12 col-md-6" v-if="form.tipo == 'Proponente'" label="Classificação"  :options="options.classificacao" v-model="form.classificacao" ref="classificacao" required/>
            <input-select class="col-12 col-md-6" v-if="form.tipo == 'Proponente'" label="Segmento"  :options="options.segmento" v-model="form.segmento" ref="segmento" required/>
            <input-text :class="`col-12 col-md-${form.tipo == 'Proponente' ? 6 : 9}`" label="Razão social" v-model="form.razaoSocial" ref="razao" required/>
            <input-text :class="`col-12 col-md-${form.tipo == 'Proponente' ? 6 : 12}`" label="Nome fantasia" v-model="form.nomeFantasia" ref="fantasia" required/>
            
            <input-mask :mask="['(##) ####-####', '(##) #####-####']" class="col-12 col-md-4" label="Telefone" v-model="form.telefone" ref="telefone" required/>
            <input-text class="col-12 col-md-4" label="Site" v-model="form.site" ref="site"/>
            <input-text class="col-12 col-md-4"  type="email" label="E-mail" v-model="form.email" ref="email"/>

            <input-text class="col-12 col-md-2" @blur="buscarCep" label="CEP" v-model="form.endereco.cep" ref="cep" required/>
            <input-text class="col-12 col-md-4" label="Endereço" v-model="form.endereco.logradouro" ref="endereco" required/>
            <input-text class="col-12 col-md-2" label="N°" v-model="form.endereco.numero" ref="numero" required/>
            <input-text class="col-12 col-md-4" label="Complemento" v-model="form.endereco.complemento" ref="complemento"/>

            <input-text class="col-12 col-md-4" label="Bairro" v-model="form.endereco.bairro" ref="bairro" required/>
            <input-select class="col-12 col-md-4" label="UF" v-model="form.endereco.uf" :options="options.uf" ref="estado" required/>
            <input-select class="col-12 col-md-4" label="Cidade" :options="options.cidades" v-model="form.endereco.cidade" ref="cidade" required/>

            <div class="col-12">
                <b-button variant="success" type="submit" v-if="!id ? permissao.c : permissao.u" @click="salvar">
                    <i class="fa-solid fa-check mr-2"></i>
                    Salvar
                </b-button>
            </div>
        </div>
    </b-card>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import InputMask from "@/components/inputs/InputMask";
import InputSelect from "@/components/inputs/InputSelect";
import InputDateTime from "@/components/inputs/InputDateTime";


import helpers from "@/common/utils/helpers";

import InfosService from "@/common/services/infos/infos.service";
import EmpresasService from "@/common/services/empresas/empresas.service";

import { START_LOADING, STOP_LOADING } from "@/store/Store";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";

import UploadFoto from "@/components/uploadFoto/UploadFoto";

import {FormMixin} from "@/common/mixins/FormMixin";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import { EnderecoEmpresa } from "@/common/models/EnderecoEmpresa.js";

import cloneDeep from "lodash.clonedeep";

export default {
    name : "FormularioEmpresa",
    mixins : [FormMixin, AlertasMixin],
    props : ['id'],
    components : {
        InputText,
        InputMask,
        InputSelect,
        UploadFoto,
        InputDateTime
    },
    data : () => ({
        options : {
            tipoEmpresa : helpers.TipoEmpresa,
            segmento : helpers.Segmento,
            classificacao : helpers.Classificacao,
            uf: helpers.UF,
            cidades : []
        },
        form : {
            tipo: null,
            razaoSocial: null,
            nomeFantasia: null,
            telefone: null,
            email: null,
            logoDaEmpresa: null,
            cnpj: null,
            site: null,
            inicioOperacao: null,
            endereco: new EnderecoEmpresa({}),
            codigoANEEL: null,
            classificacao: null,
            segmento: null
        }
    }),
    methods : {
        buscarCep : function(){
            if (this.form.endereco.cep.length >= 8){
                this.$store.dispatch(START_LOADING);
                InfosService.buscarEndereco(this.form.endereco.cep)
                .then((result) => {
                    this.form.endereco = new EnderecoEmpresa({ ...result.data.data });
                })
                .finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            }
        },
        buscar() {
            this.$store.dispatch(START_LOADING);
            EmpresasService.buscarPorId(this.id).then((res) => {
                console.log(res)
                let data = res.data.data;
                this.form = data;
                if(!this.form.endereco)
                    this.form.endereco = {
                        numero: null,
                        complemento: null,
                        bairro: null,
                        logradouro: null,
                        cidade: null,
                        cep: null,
                        uf: null
                    }
            }).catch(() => {
                this.alertaErro("Erro ao buscar");
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        salvar(){
            if (!this.validateState()) return;

            this.confirmar("Aviso","Deseja realmente salvar dados da empresa?").then(confirmado => {
                if(!confirmado) return;

                let form = cloneDeep(this.form);

                if(form.tipo != 'Proponente'){
                    form.codigoANEEL = '';
                    form.segmento = '';
                    form.classificacao = '';
                }

                form.cnpj = form.cnpj.replace(/[^0-9]/g, "");
                form.endereco.cep = form.endereco.cep.replace(/[^0-9]/g, "");
                
                this.$store.dispatch(START_LOADING);
                EmpresasService.salvar(form).then(() => {
                    this.alertaSucesso("Empresa salva com sucesso!").then(() => {
                        this.$router.push({ name: "empresas" });
                    });                    
                }).catch((err) => {
                    this.alertaErro(err.response.data.errors);
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            })
        }
    },
    mounted() {
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
        { titulo: this.$t("MENU.EMPRESAS"), to : { name: 'empresas'} },
        {
            titulo: !this.id ? this.$t("GERAL.CADASTRAR") : this.$t("GERAL.EDITAR"),
        },
        ]);

        if(this.id){
            this.buscar();
        }
    },
    watch : {
        'form.endereco.uf' : function(){
            if(!this.form.endereco)
                return;
            InfosService.buscarCidades(this.form.endereco.uf).then(res => {
                this.options.cidades = res.data.data.map(el => {
                    return {
                        text : el.nome,
                        value : el.nome
                    }
                });
            });
        }
    },
    computed : {
        permissao() {
            return this.$store.getters['app/retornaPermissao']('Empresas');
        }, 
        ehAdmin() {
            return this.$store.getters['app/ehAdmin'];
        },
    }
}
</script>
<style lang="">
    
</style>